import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {
  IAuthModalProps,
  ILoginActionData,
  IRootState,
} from '../../interfaces';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import { LoginRequest, ForgotPasswordRequest } from '../../action';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { logger } from '../../helper/Logger';


class AuthModal extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      open: false,
      show: false,
      sidebar: false,
      searchbar: false,
      submenu: false,
      modalLabel: 'login',
    };
  }


  handleClose = () => {
    logger('calling............');
    this.setState({
      show: false,
      modalLabel: 'login',
    });
  };

  // To manage forgot password modal
  forgotShow = () => {   
    // console.log(('forgotShowforgotShow')
    this.setState({ modalLabel: 'forgot' });
  };
  resetShow = () => {
    this.setState({ modalLabel: 'reset' });
  };
  // To manage login modal
  showLoginModal = () => {
    this.setState({ modalLabel: 'login' });
  };

  componentDidUpdate = (prevProps: any) => {
    const { forgotPasswordReducer } = this.props;
    // To close the login popup modal
    if (
      prevProps.forgotPasswordReducer &&
      prevProps.forgotPasswordReducer.isLoading !== forgotPasswordReducer.isLoading &&
      !forgotPasswordReducer.isError
    ) {
      // this.props.handleClose();
      this.showLoginModal()
      this.setState({ modalLabel: 'login' });
    }
  };

  render() {
    // console.log(('index-modalLabel', this.props.modalLabel)
    const { loginReducer } = this.props;
    const { show, modalLabel } = this.state;
    return (
      // <Modal
      //   centered
      //   show={show}
      //   className={'login-modal'}
      //   onHide={this.props.handleClose}
      // >
      <Modal.Body>
        {/* <Button
            variant='link'
            className='btn-close'
            onClick={this.props.handleClose}
          >
            &times;
          </Button> */}          
        {modalLabel === 'login' ? (
          <Login
            forgotShow={this.forgotShow}
            resetShow={this.resetShow}
            onLogin={this.props.onLogin}
            loginReducer={loginReducer}
            {...this.props}
          />
        ) : (
            <ForgotPassword
              forgotPasswordReq={this.props.forgotPasswordReq}
              checkPage={modalLabel === 'reset' ? 'Reset' : 'Forgot'}
              showLoginModal={this.showLoginModal} 
              {...this.props}
            />
          )}
      </Modal.Body>
      // </Modal>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  loginReducer: state.loginReducer,
  forgotPasswordReducer: state.forgotPasswordReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onLogin: (data: ILoginActionData) => {
      dispatch(LoginRequest(data));
    },
    forgotPasswordReq: (email: string) => {
      dispatch(ForgotPasswordRequest({ email }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuthModal);
